// What Quick Settings shows for a setting a table does not carry. Shared by
// the drawer and the Tables page tools that change the same settings (#1534).

export const defaultCells = {
  frequencies: false,
  columnPercents: true,
  rowPercents: false,
  percentSign: false,
  missingAsZero: false,
  missingAsBlank: false,
  zeroAsBlank: false,
  blankAsChar: false,
  percentsAsProportions: false,
  thousandsSeparator: false,
  showRedundant100: false,
}

export const defaultDecimals = {
  frequencies: 0,
  percents: 1,
  statistics: 2,
  expressions: 2,
}

export const defaultSignificance = {
  visible: false,
  type: 'ColumnGroups' as const,
  propStat: 'Z' as const,
  meanStat: 'T' as const,
  autoParam: false,
  letters: 'Column' as const,
  appendLetters: false,
  headcount: 'Weighted' as const,
  meanPoolVariance: false,
  propPooledEst: false,
  continuityCorr: false,
  skipBase30: false,
  skipCell5: false,
  lettersLong: false,
  oneTailed: false,
  hiLoTest: false,
}

export const defaultEdge = {
  baseCount: false,
}

export const defaultTitles = {
  name: true,
  top: true,
  side: true,
  filter: true,
  weight: true,
  status: true,
}

export const defaultCorner = {
  priority: 'Side' as const,
  netResp: false,
}

export const defaultSpecProperties = {
  initAsMissing: false,
  excludeNE: false,
  padHierarchics: false,
  arithOverStats: false,
  fullStats: false,
}
